<template>
    <v-app>
        <v-main class="main">

            <!-- Sidebar -->
            <AdminSidebar :drawerOpen="drawerOpen" :collapsed="isSidebarCollapsed" :isMobile="isMobile"
                @update:drawerOpen="drawerOpen = $event" />

            <!-- Main Content -->
            <v-container fluid class="main-content pa-4">

                <!-- Header -->
                <Header :isDarkMode="isDarkMode" :isMobile="isMobile" @toggle-sidebar="toggleSidebar" />

                <!-- Page Title -->
                <h2 class="report-title mt-4">Reset User Password</h2>

                <!-- Form Card -->
                <div class="form-wrapper">
                    <v-card class="table-card mt-3">
                        <v-row class="stats text-center mt-4" dense>
                            <v-col cols="12" sm="6" md="12">
                                <Tabs value="0">
                                    <TabList>
                                        <Tab value="0" as="div" class="flex items-center gap-2">
                                            <Avatar
                                                image="https://primefaces.org/cdn/primevue/images/avatar/amyelsner.png"
                                                shape="circle" />
                                            <span class="font-bold whitespace-nowrap">Change you password</span>
                                        </Tab>
                                        <!-- <Tab value="1" as="div" class="flex items-center gap-2">
                                        <Avatar image="https://primefaces.org/cdn/primevue/images/avatar/onyamalimba.png" shape="circle" />
                                        <span class="font-bold whitespace-nowrap">Onyama Limba</span>
                                    </Tab>
                                    <Tab v-slot="slotProps" value="2" asChild>
                                        <div :class="['flex items-center gap-2', slotProps.class]" @click="slotProps.onClick" v-bind="slotProps.a11yAttrs">
                                            <Avatar image="https://primefaces.org/cdn/primevue/images/avatar/ionibowcher.png" shape="circle" />
                                            <span class="font-bold whitespace-nowrap">Ioni Bowcher</span>
                                            <Badge value="2" />
                                        </div>
                                    </Tab> -->
                                    </TabList>
                                    <TabPanels>
                                        <TabPanel value="0" as="p" class="m-0">
                                            <form @submit.prevent="submitReset">
                                                <div v-if="errorMessage" class="form-message error">
                                                    {{ errorMessage }}
                                                </div>

                                                <div v-if="successMessage" class="form-message success">
                                                    {{ successMessage }}
                                                </div>

                                                <!-- Username / Email (read-only) -->
                                                <div class="flex flex-col gap-2 spacing text-left w-full relative">
                                                    <label class="text-sm font-medium text-gray-700">Current
                                                        Password</label>
                                                    <input v-model="currentPassword"
                                                        :type="showPassword ? 'text' : 'password'"
                                                        placeholder="••••••••" class="modern-input pr-10" />

                                                    <!-- Eye icon -->
                                                    <button type="button" @click="togglePassword"
                                                        class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-black">
                                                        <svg v-if="!showPassword" xmlns="http://www.w3.org/2000/svg"
                                                            fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                                            class="w-5 h-5">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                stroke-width="2"
                                                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                        </svg>

                                                        <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none"
                                                            viewBox="0 0 24 24" stroke="currentColor" class="w-5 h-5">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                stroke-width="2"
                                                                d="M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a10.05 10.05 0 012.171-3.386m1.348-1.348A10.05 10.05 0 0112 5c4.477 0 8.268 2.943 9.542 7a10.05 10.05 0 01-1.639 3.15M3 3l18 18" />
                                                        </svg>
                                                    </button>
                                                </div>

                                                <!-- New Password -->
                                                <div class="flex flex-col gap-2 spacing text-left w-full">
                                                    <label class="text-sm font-medium text-gray-700">New
                                                        Password</label>

                                                    <!-- Input wrapper -->
                                                    <div class="relative w-full">
                                                        <input v-model="new_password"
                                                            :type="showPassword ? 'text' : 'password'"
                                                            placeholder="••••••••" class="modern-input pr-10 w-full" />

                                                        <!-- Eye icon -->
                                                        <button type="button" @click="togglePassword"
                                                            class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-black">
                                                            <svg v-if="!showPassword" xmlns="http://www.w3.org/2000/svg"
                                                                fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                                                class="w-5 h-5">
                                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                                    stroke-width="2"
                                                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                                    stroke-width="2"
                                                                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                            </svg>

                                                            <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none"
                                                                viewBox="0 0 24 24" stroke="currentColor"
                                                                class="w-5 h-5">
                                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                                    stroke-width="2"
                                                                    d="M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a10.05 10.05 0 012.171-3.386m1.348-1.348A10.05 10.05 0 0112 5c4.477 0 8.268 2.943 9.542 7a10.05 10.05 0 01-1.639 3.15M3 3l18 18" />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </div>
                                                <!-- Confirm Password -->
                                                <div class="flex flex-col gap-2 spacing text-left w-full relative mb-6">
                                                    <label class="text-sm font-medium text-gray-700">Confirm
                                                        Password</label>
                                                    <input v-model="confirmPassword"
                                                        :type="showPassword ? 'text' : 'password'"
                                                        placeholder="••••••••" class="modern-input pr-10" />

                                                    <button type="button" @click="togglePassword"
                                                        class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-black">
                                                        <svg v-if="!showPassword" xmlns="http://www.w3.org/2000/svg"
                                                            fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                                            class="w-5 h-5">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                stroke-width="2"
                                                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                        </svg>

                                                        <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none"
                                                            viewBox="0 0 24 24" stroke="currentColor" class="w-5 h-5">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                stroke-width="2"
                                                                d="M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a10.05 10.05 0 012.171-3.386m1.348-1.348A10.05 10.05 0 0112 5c4.477 0 8.268 2.943 9.542 7a10.05 10.05 0 01-1.639 3.15M3 3l18 18" />
                                                        </svg>
                                                    </button>
                                                </div>

                                                <!-- Buttons -->
                                                <div class="flex gap-4 justify-end">
                                                    <button type="button" class="login-button" @click="submitReset">
                                                        <span v-if="!loading">Reset Password <v-icon
                                                                start>mdi-lock-reset</v-icon></span>
                                                        <span v-else>Resetting Password… <v-icon
                                                                start>mdi-loading</v-icon></span>
                                                    </button>
                                                </div>

                                            </form>
                                        </TabPanel>
                                        <!-- <TabPanel value="1" as="p" class="m-0">
            
                                    </TabPanel>
                                    <TabPanel v-slot="slotProps" value="2" asChild>
                                        <div v-show="slotProps.active" :class="slotProps.class" v-bind="slotProps.a11yAttrs">
                                            <p class="m-0">
                                                
                                            </p>
                                        </div>
                                    </TabPanel> -->
                                    </TabPanels>
                                </Tabs>

                            </v-col>
                        </v-row>
                    </v-card>
                </div>
            </v-container>
        </v-main>
    </v-app>
</template>
<script setup>
import { ref, onMounted, onUnmounted } from "vue"
import { useRouter } from "vue-router"
import AdminSidebar from "@/components/AdminSidebar.vue"
import Header from "@/components/Header.vue"
import { useAuthStore } from "@/store/auth"

const auth = useAuthStore()
//const router = useRouter()

/* Sidebar state */
const isSidebarCollapsed = ref(false)
const drawerOpen = ref(false)
const isMobile = ref(false)

/* Form fields */
//const username = ref("johndoe@example.com") // prefill user email
const new_password = ref("")
const confirmPassword = ref("")
const showPassword = ref(false)
const currentPassword = ref("")
const errorMessage = ref("")
const successMessage = ref("")
const loading = ref(false)

const router = useRouter()

/* Toggle show password */
const togglePassword = () => {
    showPassword.value = !showPassword.value
}

/* Mobile */
const toggleSidebar = () => {
    if (isMobile.value) drawerOpen.value = !drawerOpen.value
    else isSidebarCollapsed.value = !isSidebarCollapsed.value
}

const checkMobile = () => {
    isMobile.value = window.innerWidth < 768
    drawerOpen.value = !isMobile.value
}

/* Lifecycle */
onMounted(async () => {
    checkMobile()
    window.addEventListener("resize", checkMobile)
    await auth.loadPartner()
})

onUnmounted(() => {
    window.removeEventListener("resize", checkMobile)
})

const submitReset = async () => {
    errorMessage.value = ""
    successMessage.value = ""

    if (!new_password.value || !confirmPassword.value) {
        errorMessage.value = "Please fill in all password fields"
        return
    }

    if (new_password.value !== confirmPassword.value) {
        errorMessage.value = "Passwords do not match"
        return
    }

    loading.value = true

    try {
        const res = await auth.resetUserPassword({
            current_password: currentPassword.value,
            new_password: new_password.value,
        })

        if (!res.success) {
            errorMessage.value = res.message || "Failed to reset password"
            return
        }

        successMessage.value = "Password reset successfully! Logging out…"

        // Logout user (you may have a store action for this)
        await auth.logout()
        // redirect to login page
        // Delay navigation by 3 seconds
        setTimeout(() => {
            router.push("/login")
        }, 3000)

    } catch (err) {
        console.error("ERROR:", err)
        errorMessage.value =
            err?.response?.data?.message ||
            err.message ||
            "Something went wrong"
    } finally {
        loading.value = false
    }
}

</script>

<style scoped>
.main {
    display: flex;
    min-height: 100vh;
}

.main-content {
    flex: 1;
    background: #f8fafc;
}

/* Card */
.table-card {
    padding: 20px;
    border-radius: 14px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
}

/* Modern Input */
.modern-input {
    width: 100%;
    height: 46px;
    margin-top: 6px;
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid #d1d5db;
    font-size: 15px;
    background: transparent;
    transition: all 0.2s ease;
}

.modern-input:focus {
    outline: none;
    border-color: #000;
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
}

/* Buttons */
.login-button {
    width: 230px;
    height: 46px;
    background: #000;
    color: #fff;
    border-radius: 10px;
    font-weight: 600;
    transition: all 0.25s ease;
}

.login-button:hover {
    background: #292828;
}

.login-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.form-wrapper {
    /* display: flex; */
    justify-content: center;
    align-items: center;
    min-height: calc(100vh - 64px);
    padding-left: 250px;
    padding-right: 250px;
}

.spacing {
    margin-bottom: 1em;
}

/* Message container */
.form-message {
    padding: 10px 14px;
    border-radius: 8px;
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 1rem;
}

/* Error message */
.form-message.error {
    background-color: #fee2e2;
    /* light red background */
    color: #b91c1c;
    /* dark red text */
    border: 1px solid #fca5a5;
    /* red border */
}

/* Success message */
.form-message.success {
    background-color: #d1fae5;
    /* light green background */
    color: #065f46;
    /* dark green text */
    border: 1px solid #6ee7b7;
    /* green border */
}
</style>
